module.exports = __webpack_public_path__ + "841ba3e7a80683d9d108cbe07ab63f98.png";